import { render } from "./DeveloperItemImageUpload.vue?vue&type=template&id=2afe81a6"
import script from "./DeveloperItemImageUpload.vue?vue&type=script&lang=js"
export * from "./DeveloperItemImageUpload.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__